import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { getCurrentAdmin, logout } from '../lib/api';

const navItems = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/users', label: 'Users' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/anti-abuse', label: 'Anti-abuse' },
  { to: '/reports', label: 'Reports' },
  { to: '/audit-log', label: 'Audit log' },
];

export function Layout(): JSX.Element {
  const meQ = useQuery({ queryKey: ['me'], queryFn: getCurrentAdmin, retry: false });
  const qc = useQueryClient();
  const navigate = useNavigate();

  const logoutMut = useMutation({
    mutationFn: logout,
    onSuccess: () => {
      qc.clear();
      navigate('/login', { replace: true });
    },
  });

  return (
    <div className="min-h-dvh bg-bg">
      <header className="border-b border-border bg-surface">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3">
          <div className="flex items-center gap-2">
            <div className="h-6 w-6 rounded-full bg-brand-navy" />
            <span className="text-lg font-bold text-brand-navy">Waylo Admin</span>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <span className="text-text-soft">{meQ.data?.email ?? '…'}</span>
            <button
              type="button"
              onClick={() => logoutMut.mutate()}
              disabled={logoutMut.isPending}
              className="text-text-soft transition hover:text-brand-navy"
            >
              {logoutMut.isPending ? 'Signing out…' : 'Sign out'}
            </button>
          </div>
        </div>
        <nav className="mx-auto max-w-6xl px-6">
          <ul className="flex gap-1 overflow-x-auto">
            {navItems.map((it) => (
              <li key={it.to}>
                <NavLink
                  to={it.to}
                  end={it.end}
                  className={({ isActive }) =>
                    'inline-block border-b-2 px-3 py-2 text-sm font-medium transition ' +
                    (isActive
                      ? 'border-brand-green text-brand-navy'
                      : 'border-transparent text-text-soft hover:text-brand-navy')
                  }
                >
                  {it.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-6">
        <Outlet />
      </main>
    </div>
  );
}
